import DiscoverDetails from './DiscoverDetails';
import DiscoverTree from '../../Containers/Discover/DiscoverTreeContainer';
import Grid from '@material-ui/core/Grid';
import React from 'react';

const Discover = (props: any) => {
    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item sm={7} xs={12}>
                    <DiscoverTree />
                </Grid>

                <Grid container item sm={5} spacing={2} xs={12}>
                    <DiscoverDetails />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default Discover;
